import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbstractControl, ValidationErrors } from '@angular/forms';

@Component({
  selector: '[i7-field-error-message]',
  templateUrl: './field-error-message.component.html',
  styleUrl: './field-error-message.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [CommonModule]
})
export class FieldErrorMessageComponent {
  @Input() control: AbstractControl | null = null;
  @Input() fieldLabel = '';
  @Input() messages: Record<string, string> = {};

  get errorMessage(): string | null {
    if (!this.control || !this.control.errors || !(this.control.touched || this.control.dirty)) return null;
    const errors = this.control.errors;
    const errorKey = Object.keys(errors)[0];
    return this.messages[errorKey] || this.defaultMessage(errorKey, errors);
  }

  private defaultMessage(errorKey: string, errors: ValidationErrors): string {
    const label = this.fieldLabel ? `${this.fieldLabel} ` : '';
    switch (errorKey) {
      case 'required': return `${label}é obrigatório.`;
      case 'email': return 'E-mail inválido.';
      case 'minlength': return `Mínimo de ${errors['minlength'].requiredLength} caracteres.`;
      case 'maxlength': return `Máximo de ${errors['maxlength'].requiredLength} caracteres.`;
      case 'pattern': return 'Formato inválido.';
      default: return 'Valor inválido.';
    }
  }
}